/* eslint-disable max-len */

import { ECoinPageParagraphTypes, ICoinPageData } from '../types'

export const usdcPage: ICoinPageData = {
  title: 'coin_991',
  description: 'coin_992',
  // description:
  //   'Check the advantages of USD Coin and borrow cryptocurrency instantly. Just send us collateral, you ' +
  //   'can get a USDC loan for any amount and time without any fees.',
  questionsBlock: {
    questions: [
      {
        title: 'coin_993',
        answer: 'coin_994',
      },
      {
        title: 'coin_995',
        answer: 'coin_996',
      },
      {
        title: 'coin_997',
        answer: 'coin_998',
      },
      {
        title: 'coin_999',
        answer: 'coin_1000',
      },
    ],
  },
  whatIs: {
    text: ['coin_1006', 'coin_1007'],
    paragraphs: [
      {
        title: 'coin_1001',
        text: ['coin_1008'],
      },
      {
        title: 'coin_1002',
        text: ['coin_1009', 'coin_1010', 'coin_1011'],
      },
      {
        title: 'coin_1003',
        text: ['coin_1012', 'coin_1013', 'coin_1014', 'coin_1015', 'coin_1016', 'coin_1017'],
      },
      {
        title: 'coin_1004',
        text: ['coin_1018', 'coin_1019'],
      },
      {
        title: 'coin_1005',
        text: ['coin_1020', 'coin_1021'],
        type: ECoinPageParagraphTypes.ul,
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/guide-to-short-selling-with-coinrabbit-bear-market-loans/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/06/Bear-loans.png',
        imageAlt: 'USDC cryptocurrency review 1',
      },
      {
        link: 'https://coinrabbit.io/blog/coinrabbit-earnings-interest-review/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/06/integration-7CR_EARN1.png',
        imageAlt: 'USDC cryptocurrency review 2',
      },
      {
        link: 'https://coinrabbit.io/blog/crypto-lending-growing-market-emerges-opportunities/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2021/05/photo_2021-05-26_21-10-19.jpg',
        imageAlt: 'USDC cryptocurrency review 3',
      },
    ],
  },
}
